module.exports = __webpack_public_path__ + "img/attachment-dark.aa9a9709.svg";